import { useEffect, useState } from 'react';

/**
 * Asztali meret-e a nezet.
 *
 * Az elrendezes nagy reszet CSS intezi (`md:` valtozatok), ezert erre a
 * horogra ritkan van szukseg - de nem mindent lehet CSS-bol eldonteni. A
 * kezdolapon peldaul az a KERDES, hogy atiranyitsunk-e egy csatornara:
 * asztalon igen (ott a lista amugy is latszik oldalt), mobilon nem, mert ott
 * epp a lista a kezdolap.
 *
 * A hatarertek megegyezik a Tailwind `md` toresponjaval - ha az valtozik, ez
 * is valtozzon vele.
 */
const DESKTOP_QUERY = '(min-width: 768px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window === 'undefined' || window.matchMedia(DESKTOP_QUERY).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(DESKTOP_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsDesktop(event.matches);

    setIsDesktop(query.matches);
    query.addEventListener('change', handler);
    return () => query.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}

/**
 * Van-e IGAZI hover ezen az eszkozon.
 *
 * Nem a kepernyo merete a kerdes - egy 1024 keppontos tablagepen sincs
 * egermutato. Amig a lebego akciosav (reakcio, valasz, tovabbi muveletek) csak
 * hoverre jelent meg, addig ezeken az eszkozokon gyakorlatilag elerhetetlen
 * volt: a "hover" ott legfeljebb a kattintas veletlen mellekhatasa.
 *
 * Ahol ez hamis, ott a hosszu nyomas hozza elo ugyanezeket a muveleteket
 * (lasd `useLongPress` es `MessageSheet`).
 */
const HOVER_QUERY = '(hover: hover) and (pointer: fine)';

export function useHasHover(): boolean {
  const [hasHover, setHasHover] = useState(
    () => typeof window === 'undefined' || window.matchMedia(HOVER_QUERY).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(HOVER_QUERY);
    const handler = (event: MediaQueryListEvent) => setHasHover(event.matches);

    setHasHover(query.matches);
    query.addEventListener('change', handler);
    return () => query.removeEventListener('change', handler);
  }, []);

  return hasHover;
}
